// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","icon":"leasingQualifiedFilter_icon__VDTNX"};